import { useDrawerToggle } from '@csp/csp-web-hooks';
import { useEffect } from 'react';
import { useHbsSearchParams } from '../../hbs/hook/useHbsSearchParams';
import { BioSampleDetailsToggle } from '../model/BioSampleDetailsToggle';
import { useBioSampleDetailsNavigation } from './useBioSampleDetailsNavigation';

export const useBioSampleDetailsToggle = (): BioSampleDetailsToggle => {
  const drawerToggle = useDrawerToggle();
  const { sampleId, sampleCode } = useHbsSearchParams();
  const navigation = useBioSampleDetailsNavigation();

  useEffect(() => {
    const hasSearchParams = !!sampleId || !!sampleCode;
    if (hasSearchParams && !drawerToggle.isOpen) {
      drawerToggle.open();
    } else if (!hasSearchParams && drawerToggle.isOpen) {
      drawerToggle.closeAsync();
    }
  }, [sampleId, sampleCode, drawerToggle]);

  return {
    ...drawerToggle,
    ...navigation,
  };
};
